import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Api } from '@.api';
import { BrandResponseType } from '@.api/methods';
import { useArchiveBrand, useRestoreBrand } from '@/features/BrandActionConfirmModal/model';
import { useDeleteBrand } from '@/features/DeleteBrand/lib';
import { LinkHelper, useLingualField } from '@/Services';

export const useBrandDetailPage = (brandId?: string) => {
    const [brand, setBrand] = useState<BrandResponseType | null>(null);
    const navigator = useNavigate();

    const id = Number(brandId);

    const fetchBrand = () => {
        Api.brands()
            .getById(Number(id))
            .onSuccess((res) => setBrand(res.data))
            .onNotFound(() => navigator(LinkHelper.dataBrands));
    };

    const archiveBrand = useArchiveBrand();
    const restoreBrand = useRestoreBrand();
    const deleteBrand = useDeleteBrand({ onSuccessDelete: fetchBrand });

    const brandName = useLingualField(brand ?? undefined);

    const toEdit = () => navigator(LinkHelper.dataBrandsEditId(id));

    const modals = [archiveBrand.modal, restoreBrand.modal, deleteBrand.modal];

    useEffect(() => {
        fetchBrand();
    }, []);

    return {
        modals,
        brand,
        brandName,
        archiveBrand,
        restoreBrand,
        deleteBrand,
        toEdit,
    };
};
